import { render } from "./Grade.vue?vue&type=template&id=1a2e9c52&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"

import "./Grade.vue?vue&type=style&index=0&id=1a2e9c52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2e9c52"]])

export default __exports__